import React from "react";
import DetailBlock from "./DetailBlock";
import Row from 'react-bootstrap/Row';

const DetailsSummary = (props) => {
  const getSchoolDetails = schoolDetails => [
    {
      label: "Purchase order",
      text: schoolDetails.schoolOrder
    },
    {
      label: "Contact name",
      text: schoolDetails.fullname
    },
    {
      label: "Position",
      text: schoolDetails.job
    },
    {
      label: "Phone",
      text: schoolDetails.telephone
    },
    {
      label: "Dispatch email",
      text: schoolDetails.email
    },
    {
      label: "Finance email",
      text: schoolDetails.financeemail
    },
    {
      label: "VAT number",
      text: schoolDetails.vat
    },
    {
      label: "DfE number",
      text: schoolDetails.dfes
    },
    {
      label: "Centre name",
      text: schoolDetails.org
    },
    {
      label: "Mailing address",
      text: schoolDetails.mailingAddress
    },
    {
      label: "Postcode",
      text: schoolDetails.postCode
    },
    {
      label: "Country",
      text: schoolDetails.country
    }
  ];

  const { schoolDetails, basket } = props;
  const url = window.location.href;
  let finalSchoolDetails;
  if (!url.includes("dsdb-confirm-order")) {
    const basketZero = basket.map((basket, index) =>
      basket.price === ".0000" ? 0 : parseInt(basket.price, 10)
    );
    let basketTotal = basketZero.reduce((a, b) => a + b, 0);
    const basketSubTotalToNumber = basketTotal || 0;
    if (basketSubTotalToNumber === 0) {
      const noFinanceArray = getSchoolDetails(schoolDetails).filter(
        (item, index) => {
          return item.label !== "Finance email";
        }
      );
      finalSchoolDetails = noFinanceArray;
      console.log(noFinanceArray);
    } else {
      finalSchoolDetails = getSchoolDetails(schoolDetails);
    }
  } else {
    finalSchoolDetails = getSchoolDetails(schoolDetails);
  }

  return (
    <Row>
      {finalSchoolDetails.map((item, index) => (
        <DetailBlock key={index} label={item.label} text={item.text} />
      ))}
    </Row>
  );
}

export default DetailsSummary;
